import { ArrowUpRight } from "lucide-react";
import { BUSINESS, IMAGES } from "@/constants";
import { Reveal } from "@/components/Reveal";

const services = [
  {
    id: "hair",
    title: "Hair Artistry",
    desc: "Cuts, colour, keratin & styling that turns heads.",
    img: IMAGES.hair,
    span: "md:col-span-2 md:row-span-2",
  },
  {
    id: "nails",
    title: "Nail Studio",
    desc: "Manicure, pedicure, gel polish & extensions.",
    img: IMAGES.nails,
    span: "",
  },
  {
    id: "facial",
    title: "Facials & Skin",
    desc: "Deep-cleanse & glow rituals for radiant skin.",
    img: IMAGES.facial,
    span: "",
  },
  {
    id: "waxing",
    title: "Waxing & Threading",
    desc: "Gentle full-body waxing & precision brow threading.",
    img: IMAGES.waxing,
    span: "",
  },
  {
    id: "henna",
    title: "Henna Art",
    desc: "Bridal & occasion mehndi, drawn with love.",
    img: IMAGES.henna,
    span: "",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-28 sm:py-36 bg-surface/40"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <Reveal className="flex flex-wrap items-end justify-between gap-6 mb-16">
          <div>
            <span className="text-xs font-semibold tracking-[0.3em] uppercase text-gold">
              What We Do
            </span>
            <h2 className="mt-5 font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-bone leading-[1.05]">
              The full salon menu,
              <br />
              <em className="text-gold-gradient italic">under one roof.</em>
            </h2>
          </div>
          <p className="max-w-xs text-sand text-sm leading-relaxed">
            Tap any service to book it instantly on WhatsApp — or call us and
            we'll find you the perfect slot.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-5 auto-rows-[280px]">
          {services.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.08} className={s.span}>
              <a
                href={BUSINESS.whatsappWithText(
                  `Hi Shine Space! I'd like to book: ${s.title}`
                )}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`service-card-${s.id}`}
                className="group relative block w-full h-full overflow-hidden rounded-sm border border-line"
              >
                <img
                  src={s.img}
                  alt={s.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent opacity-90 group-hover:opacity-70 transition-opacity duration-700" />
                <div className="absolute inset-x-0 bottom-0 p-6 sm:p-8">
                  <div className="flex items-end justify-between gap-4">
                    <div>
                      <span className="text-[10px] font-semibold tracking-[0.3em] uppercase text-gold">
                        0{i + 1}
                      </span>
                      <h3 className="mt-1 font-serif text-2xl sm:text-3xl text-bone">
                        {s.title}
                      </h3>
                      <p className="mt-1.5 text-sm text-sand max-w-[240px]">
                        {s.desc}
                      </p>
                    </div>
                    <span className="shrink-0 w-11 h-11 rounded-full border border-bone/25 flex items-center justify-center text-bone group-hover:bg-gold group-hover:text-ink group-hover:border-gold transition-colors duration-500">
                      <ArrowUpRight size={16} />
                    </span>
                  </div>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
